<template>
  <div id="client-filter">
    <dropdown-card width="100%" height="120px">
      <template v-slot:header>
        <p>{{ $t("usersScreen.clientFilter.title") }}</p>
      </template>
      <div class="filters">
        <div class="word-filter">
          <basic-input
            width="100%"
            :placeholder="$t('clientFilter.wordFilter.placeholder')"
            :type="'text'"
            class="word-filter"
            v-model="wordFilter"
          />
        </div>
      </div>
    </dropdown-card>
  </div>
</template>

<script>
export default {
  name: "ClientFilter",
  data() {
    return {
      wordFilter: undefined
    };
  },
  watch: {
    wordFilter() {
      this.$emit("wordFilterChanged", this.wordFilter);
    }
  }
};
</script>
<style lang="scss" scoped>
#client-filter {
  width: 100%;
  .filters {
    margin-top: 20px;
    height: 100%;
    width: 100%;
    .word-filter {
      width: 100%;
      max-width: 800px;
    }
  }
}
</style>
